import React, { Component } from 'react';
// @material-ui/core components
import { withStyles } from '@material-ui/core/styles';
// core components
import { Table, Button } from 'reactstrap';
import { upload } from '../../store/actions/vendor/Vendor';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Grid from '@material-ui/core/Grid';
import CustomInputWithIcons from '../../components/CustomInput/CustomInputWithIcons.js';
import Textsms from '@material-ui/icons/Textsms';
import ShoppingBasket from '@material-ui/icons/ShoppingBasket';
import MonetizationOn from '@material-ui/icons/MonetizationOn';
import Queue from '@material-ui/icons/Queue';
import {
  getProductDetails,
  getSuperCategory as getAllCategoryList,
  getAllSubCategory,
  getAllCategory as getCategoryList,
  updateProduct
} from '../../store/actions/vendor/Vendor';
import CardHeader from '../../components/Card/CardHeader.js';
import CardBody from '../../components/Card/CardBody.js';
import CardFooter from '../../components/Card/CardFooter.js';
import GridItem from '../../components/Grid/GridItem.js';
import GridContainer from '../../components/Grid/GridContainer.js';
import CustomInput from '../../components/CustomInput/CustomInput.js';
import { Divider } from '@material-ui/core';
import { Checkbox, FormControlLabel } from "@material-ui/core";
import { DeleteOutline } from '@material-ui/icons';

const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

class ProductEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      imageUploadMessage: '',
      productDetails: {
        name: 'loading..',
        superCategoryId: 'loading..',
        categoryId: 'loading..',
        subCategoryId: 'loading..',
        price: 'loading..',
        productId: 'ssdsddf',
        quantity: 0,
        description: 'Loading...',
        image: 'https://inolemit.sirv.com/utils/35%20(1).gif',
        isGm: false,
        isMl: false,
        isOffer: false,
        offerPrice: null
      },
      valueUserLoginId: '',
      varients: []
    };
  }

  componentDidMount() {
    var productId = this.props.match.params.productId;
    this.props.getProductDetails(productId);
    this.props.getAllCategoryList();
    this.setState({
      valueUserLoginId: localStorage.getItem('uid') || ''
    });
    // this.getDetails(this.props.match.params.productId);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.productDetails !== this.props.productDetails && this.props.productDetails) {
      this.setState({
        productDetails: this.props.productDetails,
        varients: this.props.productDetails.variant,
        superCategoryId: this.props.productDetails.superCategoryId,
        categoryId: this.props.productDetails.categoryId,
        name: this.props.productDetails.name,
        image: this.props.productDetails.image,
        productId: this.props.productDetails.id,
        subCategoryId: this.props.productDetails.subCategoryId,
        price: this.props.productDetails.price,
        quantity: this.props.productDetails.quantity,
        description: this.props.productDetails.description,
        isMl: this.props.productDetails.isMl,
        isGm: this.props.productDetails.isGm,
        isOffer: this.props.productDetails.isOffer,
        offerPrice: this.props.productDetails.offerPrice
      })
      this.props.getCategoryList(this.props.productDetails.superCategoryId);
      this.props.getAllSubCategory(this.props.productDetails.categoryId);
    }
    else if (prevProps.subCategories !== this.props.subCategories) {
      if (this.props.subCategories[0] === undefined) {
        alert(
          'Please add a subcategory first so that you can add product using this category.'
        )
      }

    } else if (prevProps.categories !== this.props.categories) {
      if (this.props.categories[0] === undefined) {
        alert(
          'Please add a category first so that you can add product using this super-category.'
        )
      }
    }
  }

  getDetails = (productId) => {
    if (this.props.productDetails !== undefined) {
      setTimeout(() => {
        this.setState((prevState) => ({
          productDetails: {
            ...prevState.productDetails,
            superCategoryId: this.props.productDetails.superCategoryId,
            categoryId: this.props.productDetails.categoryId,
            name: this.props.productDetails.name,
            image: this.props.productDetails.image,
            productId: this.props.productDetails.id,
            subCategoryId: this.props.productDetails.subCategoryId,
            price: this.props.productDetails.price,
            quantity: this.props.productDetails.quantity,
            description: this.props.productDetails.description,
            isGm: this.props.productDetails.isGm,
          }
        }));
        this.props.getCategoryList(this.state.productDetails.superCategoryId);
        this.props.getAllSubCategory(this.state.productDetails.categoryId);
      }, 6000);

      setTimeout(() => {
        this.props.getAllSubCategory(this.state.productDetails.categoryId);
      }, 8000);
    } else {
      setTimeout(() => {
        this.setState((prevState) => ({
          productDetails: {
            ...prevState.productDetails,
            superCategoryId: this.props.productDetails.superCategoryId,
            categoryId: this.props.productDetails.categoryId,
            name: this.props.productDetails.name,
            image: this.props.productDetails.image,
            productId: this.props.productDetails.id,
            quantity: this.props.productDetails.quantity,
            subCategoryId: this.props.productDetails.subCategoryId,
            price: this.props.productDetails.price,
            description: this.props.productDetails.description
          }
        }));
        this.props.getCategoryList(this.state.productDetails.superCategoryId);
        this.props.getAllSubCategory(this.state.productDetails.categoryId);
      }, 5000);
      setTimeout(() => {
        this.props.getAllSubCategory(this.state.productDetails.categoryId);
      }, 8000);
    }
  };
  onUpload = (event) => {
    this.setState({
      imageUploadMessage: 'Uploading the file, please wait...'
    });

    let data = new FormData();
    data.append('files', event.target.files[0]);

    // Upload image
    this.props
      .upload(data)
      .then((response) => {
        if (response.status === 201) {
          this.setState({
            imageUploadMessage: 'File uploaded successfully.'
          });
          let productDetails = this.state.productDetails;
          productDetails.image = `${response.data.uploads[0].path}`;
          this.setState({
            productDetails
          });
        } else {
          this.setState({
            imageUploadMessage: 'Please, try Again'
          });
        }
      })
      .catch((error) => {
        this.setState({
          imageUploadMessage:
            'An error occurred while executing the query. Please try Again'
        });
      })
      .then(() => {
        console.log('Image uploaded');
      });
  };
  onChangeSelect = (event) => {
    let productDetails = this.state.productDetails;
    productDetails[event.target.name] = event.target.value;

    this.setState({
      productDetails
    });
    this.props.getCategoryList(this.state.productDetails.superCategoryId);
  };
  handleChange = (selectedOption) => {
    this.setState({ selectedOption }, () =>
      console.log(`Option selected:`, this.state.selectedOption)
    );
  };
  onChangeSelect2 = (event) => {
    let productDetails = this.state.productDetails;
    productDetails[event.target.name] = event.target.value;

    this.setState({
      productDetails
    });
    this.props.getAllSubCategory(this.state.productDetails.categoryId);
  };
  onChangeSelect3 = (event) => {
    let productDetails = this.state.productDetails;
    productDetails[event.target.name] = event.target.value;

    this.setState({
      productDetails
    });
  };
  handleChange = (event) => {
    const id = event.target.id;
    this.setState({
      ...this.state.productDetails,
      [id]: event.target.value
    });
  };

  handleVarient = () => {
    var varients = this.state.varients
    if (varients) {
      varients.push({})
      this.setState({
        varients
      })
    } else {
      this.setState({
        varients: [{}]
      })
    }
  }

  handleVarientChange(index, event) {
    var varients = this.state.varients
    varients[index].heading = event.target.value
    this.setState({
      varients
    })
  }

  handleVarientAddProduct(index) {
    var varients = this.state.varients
    var product_variant = varients[index].product_variant
    if (product_variant) {
      product_variant.push({})
    } else {
      product_variant = [{}]
    }
    varients[index].product_variant = product_variant
    this.setState({
      varients
    })
  }

  handleVarientProductChange(index, product_index, key, event) {
    var varients = this.state.varients
    var product_variant = varients[index].product_variant
    product_variant[product_index][key] = event.target.value
    varients[index].product_variant = product_variant
    this.setState({
      varients
    })
  }

  onChange = (event) => {
    let productDetails = this.state.productDetails;
    productDetails[event.target.name] = event.target.value;

    this.setState({
      productDetails
    });
  };

  onSubmit = (event) => {
    event.preventDefault();
    var varients = this.state.varients
    var productDetails = this.state.productDetails
    var productObj = {
      superCategoryId: productDetails.superCategoryId,
      categoryId: productDetails.categoryId,
      name: productDetails.name,
      image: productDetails.image,
      productId: productDetails.id,
      subCategoryId: productDetails.subCategoryId,
      price: productDetails.price,
      quantity: productDetails.quantity,
      description: productDetails.description,
      isGm: productDetails.isGm,
      isMl: productDetails.isMl,
      isOffer: productDetails.isOffer,
      offerPrice: productDetails.offerPrice
    }
    if (varients && varients.length > 0) {
      productObj.variant = varients
    }
    this.props.updateProduct(productObj).then(() => {
      const query = new URLSearchParams(this.props.location.search)
      const page_no = query.get('page_no')
      const category = query.get('category')
      const sub_category = query.get('sub_category')
      if(page_no){
        var url = '/vendor/products?page_no='+page_no
        if(category){
          url +='&category='+category
        }
        if(sub_category){
          url +='&sub_category='+sub_category
        }
        this.props.history.push(url)
      }else{
        var url = '/vendor/products'
        if(category){
          url +='?category='+category
          if(sub_category){
            url +='&sub_category='+sub_category
          }
        }
        else if(sub_category){
          url +='?sub_category='+sub_category
        }
        
      }
    });
  };

  onChangeQuantityType(event) {
    let productDetails = this.state.productDetails;
    productDetails[event.target.name] = event.target.value;

    this.setState({
      productDetails
    });
  }

  changeIsGmMl(event) {
    let productDetails = this.state.productDetails;
    productDetails[event.target.name] = !productDetails[event.target.name];

    this.setState({
      productDetails
    });
  }

  changeIsOffer(event) {
    let productDetails = this.state.productDetails;
    productDetails[event.target.name] = !productDetails[event.target.name];
    if (!productDetails[event.target.name]) {
      productDetails['offerPrice'] = null
    }

    this.setState({
      productDetails
    });
  }

  deleteProductVariant(index, product_index) {
    var varients = this.state.varients
    var product_variant = varients[index].product_variant
    product_variant.splice(product_index, 1);
    varients[index].product_variant = product_variant
    this.setState({
      varients
    })
  }

  deleteProduct(index) {
    var varients = this.state.varients
    varients.splice(index, 1);
    this.setState({
      varients
    })
  }


  render() {
    const { classes } = this.props;
    const { varients } = this.state;
    return (
      <>
        <CardHeader color="primary">
          <h4 className={classes.cardTitleWhite}>Update a product</h4>
          <p className={classes.cardCategoryWhite}>
            When choosing icon, PNG images would be better over JPG or imap
          </p>
        </CardHeader>
        <CardBody>
          <br />
          <GridContainer>
            <GridItem xs={12} sm={12} md={3}>
              <div className={classes.formControl}>
                <Grid container spacing={1} alignItems="flex-end">
                  <Grid item>
                    <ShoppingBasket style={{ color: '#00000090' }} />
                  </Grid>
                  <Grid item>
                    <CustomInputWithIcons
                      labelText="Product Name"
                      value={this.state.productDetails.name}
                      onChange={this.onChange}
                      name="name"
                      id="name"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={3}>
              <div className={classes.formControl}>
                <Grid container spacing={1} alignItems="flex-end">
                  <Grid item>
                    <MonetizationOn style={{ color: '#00000090' }} />
                  </Grid>
                  <Grid item>
                    <CustomInputWithIcons
                      labelText="Product Price"
                      value={this.state.productDetails.price}
                      onChange={this.onChange}
                      name="price"
                      id="price"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <div className={classes.formControl}>
                <Grid container spacing={1} alignItems="flex-end">
                  <Grid item>
                    <Queue style={{ color: '#00000090' }} />
                  </Grid>
                  <Grid item>
                    <CustomInputWithIcons
                      labelText="Product quantity"
                      value={this.state.productDetails.quantity}
                      onChange={this.onChange}
                      name="quantity"
                      id="quantity"
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </GridItem>
            <br></br>
            <GridItem xs={12} sm={12} md={3} style={{ marginTop: '10px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.productDetails.isGm}
                    onChange={this.changeIsGmMl.bind(this)}
                    name="isGm"
                  />
                }
                label="Is Gram"
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={3} style={{ marginTop: '10px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.productDetails.isMl}
                    onChange={this.changeIsGmMl.bind(this)}
                    name="isMl"
                  />
                }
                label="Is Milliliter"
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={3} style={{ marginTop: '-20px' }}>
              <div className={classes.formControl}>
                <Grid container spacing={1} alignItems="flex-end">
                  <Grid item>
                    <CustomInput
                      labelText="Product Image"
                      id="image"
                      type="file"
                      name="image"
                      accept="image/png, image/jpeg, image/jpg"
                      onChange={this.onUpload}
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                    <br />
                    <p style={{ color: '#000' }}>
                      {this.state.imageUploadMessage}
                    </p>
                  </Grid>
                </Grid>
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={6} style={{ marginTop: '10px' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.productDetails.isOffer}
                    onChange={this.changeIsOffer.bind(this)}
                    name="isOffer"
                  />
                }
                label="Offer Applicable"
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={6}>
              {this.state.productDetails.isOffer &&
                <div className={classes.formControl}>
                  <Grid container spacing={1} alignItems="flex-end">
                    <Grid item>
                      <MonetizationOn style={{ color: '#00000090' }} />
                    </Grid>
                    <Grid item>
                      <CustomInputWithIcons
                        labelText="Offer Price"
                        value={this.state.productDetails.offerPrice}
                        onChange={this.onChange}
                        name="offerPrice"
                        id="offerPrice"
                        formControlProps={{
                          fullWidth: true
                        }}
                      />
                    </Grid>
                  </Grid>
                </div>
              }
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <select
                fullWidth={true}
                required="required"
                name="superCategoryId"
                id="inputState"
                className="form-control"
                value={this.state.productDetails.superCategoryId}
                onChange={this.onChangeSelect}
                style={{ marginTop: '2.5em' }}
              >
                {this.props.superCategories.length > 0 ? (
                  this.props.superCategories.map((type) => (
                    <option value={type.id} key={type.id}>
                      {type.name}
                    </option>
                  ))
                ) : (
                  <option disabled="disabled" selected="selected">
                    Select Super-Category
                  </option>
                )}
              </select>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <select
                fullWidth={true}
                required="required"
                name="categoryId"
                id="inputState"
                className="form-control"
                value={this.state.productDetails.categoryId}
                onChange={this.onChangeSelect2}
                style={{ marginTop: '2.5em' }}
              >
                {this.props.categories.length > 0 ? (
                  this.props.categories.map((type) => (
                    <option value={type.id} key={type.id}>
                      {type.name}
                    </option>
                  ))
                ) : (
                  <option disabled="disabled" selected="selected">
                    Select Category
                  </option>
                )}
              </select>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <select
                fullWidth={true}
                required="required"
                name="subCategoryId"
                id="inputState"
                className="form-control"
                value={this.state.productDetails.subCategoryId}
                onChange={this.onChangeSelect3}
                style={{ marginTop: '2.5em' }}
              >
                {this.props.subCategories.length > 0 ? (
                  this.props.subCategories.map((type) => (
                    <option value={type.id} key={type.id}>
                      {type.name}
                    </option>
                  ))
                ) : (
                  <option disabled="disabled" selected="selected">
                    Select sub-category
                  </option>
                )}
              </select>
            </GridItem>
            <GridItem xs={12} sm={12} md={12} style={{ marginTop: '30px' }}>
              <div className={classes.formControl}>
                <Grid container spacing={3} alignItems="flex-end">
                  <Grid item>
                    <Textsms style={{ color: '#00000090' }} />
                  </Grid>
                  <Grid item>
                    <CustomInputWithIcons
                      labelText="Product description"
                      id="description"
                      value={this.state.productDetails.description}
                      name="description"
                      onChange={this.onChange}
                      formControlProps={{
                        fullWidth: true
                      }}
                    />
                  </Grid>
                </Grid>
              </div>
            </GridItem>
            {varients && varients.map((varient, index) => {
              return (
                <GridItem xs={12} sm={12} md={7} style={{ border: '1px solid', marginTop: '2%', borderRadius: '5px' }}>
                  <Grid container style={{ marginTop: '2%', paddingBottom: '1%' }}>
                    <GridItem xs={12} sm={12} md={5}>
                      <div className={classes.formControl}>
                        <Grid container spacing={1} alignItems="flex-end">
                          <Grid item>
                            <CustomInputWithIcons
                              labelText="Heading"
                              value={varient.heading}
                              onChange={(event) => { this.handleVarientChange(index, event) }}
                              name="heading"
                              id="price"
                              formControlProps={{
                                fullWidth: true
                              }}
                            />
                          </Grid>
                        </Grid>
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={5}>
                      <div className={classes.formControl}>
                        <Grid container spacing={3} alignItems="flex-end">
                          <Grid item>
                            <Button
                              type="submit"
                              onClick={() => { this.handleVarientAddProduct(index) }}
                              style={{
                                color: '#fff',
                                backgroundColor: '#9c27b0',
                                boxShadow:
                                  '0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)'
                              }}
                            >
                              Add Variant Product
                            </Button>
                          </Grid>
                        </Grid>
                      </div>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={2}>
                      <div className={classes.formControl}>
                        <Grid container spacing={1} alignItems="flex-end">
                          <Grid item>
                            <DeleteOutline style={{ cursor: 'pointer' }}
                              onClick={(event) => { this.deleteProduct(index) }}
                            />
                          </Grid>
                        </Grid>
                      </div>
                    </GridItem>
                  </Grid>
                  {varient.product_variant ? varient.product_variant.map((product_varient, product_index) => {
                    return (<Grid container style={{ marginTop: '2%', paddingBottom: '1%' }}>
                      <GridItem xs={12} sm={12} md={5}>
                        <div className={classes.formControl}>
                          <Grid container spacing={1} alignItems="flex-end">
                            <Grid item>
                              <CustomInputWithIcons
                                labelText="Name"
                                value={product_varient.name}
                                onChange={(event) => { this.handleVarientProductChange(index, product_index, 'name', event) }}
                                name="price"
                                id="price"
                                formControlProps={{
                                  fullWidth: true
                                }}
                              />
                            </Grid>
                          </Grid>
                        </div>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={5}>
                        <div className={classes.formControl}>
                          <Grid container spacing={1} alignItems="flex-end">
                            <Grid item>
                              <CustomInputWithIcons
                                labelText="Price"
                                value={product_varient.price}
                                onChange={(event) => { this.handleVarientProductChange(index, product_index, 'price', event) }}
                                name="price"
                                id="price"
                                type="number"
                                formControlProps={{
                                  fullWidth: true
                                }}
                              />
                            </Grid>
                          </Grid>
                        </div>
                      </GridItem>
                      <GridItem xs={12} sm={12} md={2}>
                        <div className={classes.formControl}>
                          <Grid container spacing={1} alignItems="flex-end">
                            <Grid item>
                              <DeleteOutline style={{ cursor: 'pointer' }}
                                onClick={(event) => { this.deleteProductVariant(index, product_index) }}
                              />
                            </Grid>
                          </Grid>
                        </div>
                      </GridItem>
                    </Grid>)
                  }) : ''}
                  <Divider></Divider>
                </GridItem>
              )
            })}
            <GridItem xs={12} sm={12} md={12} style={{ marginTop: '30px' }}>
              <div className={classes.formControl}>
                <Grid container spacing={3} alignItems="flex-end">
                  <Grid item>
                    <Button
                      type="submit"
                      onClick={this.handleVarient}
                      style={{
                        color: '#fff',
                        backgroundColor: '#9c27b0',
                        boxShadow:
                          '0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)'
                      }}
                    >
                      Add Variant
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </GridItem>
          </GridContainer>
        </CardBody>
        <CardFooter>
          <Button
            type="submit"
            onClick={this.onSubmit}
            style={{
              color: '#fff',
              backgroundColor: '#9c27b0',
              boxShadow:
                '0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)'
            }}
          >
            Update Product
          </Button>
        </CardFooter>
        <br /> <br />
        <Table hover>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Price</th>
              <th>Quantity</th>
              <th>Description</th>
              <th>Image</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>1</th>
              <th>{this.state.productDetails.name}</th>
              <td>{this.state.productDetails.price}</td>
              <td>{this.state.productDetails.quantity}</td>
              <td>{this.state.productDetails.description}</td>
              <td>
                <img
                  src={this.state.productDetails.image}
                  style={{ height: '70px' }}
                  alt=""
                />
              </td>
            </tr>
          </tbody>
        </Table>
      </>
    );
  }
}

const mapStateWithProps = (state) => ({
  productDetails: state.vendor.productDetails,
  superCategories: state.vendor.superCategories,
  categories: state.vendor.categories,
  subCategories: state.vendor.subCategories
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getAllCategoryList: () => dispatch(getAllCategoryList()),
    getCategoryList: (superCategoryId) =>
      dispatch(getCategoryList(superCategoryId, 1, true)),
    getAllSubCategory: (categoryId) => dispatch(getAllSubCategory(categoryId)),
    getProductDetails: (productId) => dispatch(getProductDetails(productId)),
    updateProduct: (categoryData) => dispatch(updateProduct(categoryData)),
    upload: (data) => dispatch(upload(data))
  };
};

export default compose(
  connect(mapStateWithProps, mapDispatchWithProps),
  withStyles(styles)
)(ProductEdit);
